module.exports = __webpack_public_path__ + "img/teeth_outline.c5c0ee5c.svg";